module.exports = __webpack_public_path__ + "img/number_up.3e332981.svg";